<div fxLayout="row" fxLayoutGap="20px">
  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxFlex="30">

    <div class="full-width px-2" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="title-small">{{ sectionName }}</div>
      <mat-icon>more_vert</mat-icon>
    </div>

    <div class="full-width py-3" fxLayout="column" fxFlexOffset="30px" fxLayoutGap="30px">
      <div class="dashboard-card full-width" fxLayout="column" fxLayoutGap="10px" *ngFor="let stat of chartStats1">
        <div class="dashboard-icon">
          <mat-icon class="material-icons-outlined">shopping_bag</mat-icon>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div class="subtitle-default stat-name">{{ chart1.stats[stat].statName }}</div>
          <div class="body-1-default">{{ dashboardUtils.displayBestStat(chart1.stats[stat], true) }}</div>
        </div>
        <div fxLayout="column" fxLayoutGap="5px">
          <div class="body-1-regular-2">{{ chart1.stats[stat].statDescription }}</div>
        </div>
      </div>

      <div class="dashboard-card full-width" fxLayout="column" fxLayoutGap="10px" *ngFor="let stat of chartStats2">
        <div class="dashboard-icon">
          <mat-icon class="material-icons-outlined">shopping_bag</mat-icon>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div class="subtitle-default stat-name">{{ chart2!.stats[stat].statName }}</div>
          <div class="body-1-default">{{ dashboardUtils.displayBestStat(chart2!.stats[stat], true) }}</div>
        </div>
        <div fxLayout="column" fxLayoutGap="5px">
          <div class="body-1-regular-2">{{ chart2!.stats[stat].statDescription }}</div>
        </div>
      </div>
    </div>

  </div>

  <div class="full-width" fxLayout="column" fxFlex="70">

    <!-- With the period toggle, the controls stack: toggle on the heading row, date pickers on
         the row beneath. Without it, everything stays on the single original row. -->
    <ng-container *ngIf="showPeriodToggle; else singleRowControls">
      <div fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div class="subtitle-default ps-2">{{ chart1.chartName }}</div>
          <mat-button-toggle-group class="custom-borderless-button-toggle dashboard-period-toggle"
                                   [hideSingleSelectionIndicator]="true"
                                   [value]="period">
            <mat-button-toggle style="height: 33px" [value]="'WEEKLY'" (click)="selectPeriod('WEEKLY')">Weekly</mat-button-toggle>
            <mat-button-toggle style="height: 33px" [value]="'MONTHLY'" (click)="selectPeriod('MONTHLY')">Monthly</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
          <ng-container *ngTemplateOutlet="dateControls"></ng-container>
        </div>
      </div>
    </ng-container>

    <ng-template #singleRowControls>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="subtitle-default ps-2">{{ chart1.chartName }}</div>
        <ng-container *ngTemplateOutlet="dateControls"></ng-container>
      </div>
    </ng-template>

    <ng-template #dateControls>
      <!-- Forwards explicitly rather than using [(date1)]: two-way binding here would update this
           component's own field and stop, leaving the parent's date bound to its initial value. -->
      <app-comparison-date-picker *ngIf="dateFilterType == 'picker'"
                                  [pickerType]="pickerType"
                                  [date1]="date1"
                                  [date2]="date2"
                                  (date1Change)="onDateChanged($event, 1)"
                                  (date2Change)="onDateChanged($event, 2)"
                                  (datePickerClosed)="datePickerClosed.emit()"></app-comparison-date-picker>

      <div *ngIf="dateFilterType == 'custom-range'">
        <app-custom-date-filter [customDateRangePresets]="customDateRangePresets"
                                [initialPreset]="initialPreset"
                                [showBorder]="false"
                                (dateRange)="getDateRange($event)"></app-custom-date-filter>
      </div>

    </ng-template>
    <div fxLayout="row">
      <div class="dashboard-canvas-container" *ngIf="chart1" [fxFlex]="chart2 ? 50 : 100">
        <canvas class="dashboard-canvas" baseChart *ngIf="!chart1.loading; else canvasLoadingSpinner"
                [height]="350"
                [data]="chart1.chartData"
                [options]="chart1.config"
                [type]="chart1.chartType">
        </canvas>
      </div>
      <div class="dashboard-canvas-container" *ngIf="chart2" [fxFlex]="50">
        <canvas class="dashboard-canvas" baseChart *ngIf="!chart2.loading; else canvasLoadingSpinner"
                [height]="350"
                [data]="chart2.chartData"
                [options]="chart2.config"
                [type]="chart2.chartType">
        </canvas>
      </div>
    </div>

  </div>

  <ng-template #canvasLoadingSpinner>
    <div fxLayout="row" fxLayoutAlign="center center" style="height: 350px">
      <mat-spinner color="primary" diameter="30"></mat-spinner>
    </div>
  </ng-template>
</div>


